import { MsgHandler } from './../../core/app/msg/msgHandler';
import * as consts from './../../core/app/common/consts';
import * as enums from './../../core/app/common/enums';
import * as aspObjects from './../../core/app/asp/aspObjects';
import { TrackObject } from './TrackObject'
import { AppConfig } from '../../core/app/app.config';
import { settings } from 'cluster';
import { userSettings } from '@core_n/common/settings';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import * as units from './../../core/app/common/units';

export class ImpactPointHandler extends MsgHandler {
  private static _self: ImpactPointHandler = null;

  private constructor() {
    super(consts.MSG_TYPE_IMPACTPOLYGON);
  }

  public static getSelf(): ImpactPointHandler {
    if (this._self == null)
      this._self = new ImpactPointHandler();
    return this._self;
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("impactpoint msg:", msgObj);
    // search the right track
    let id = "track " + msgObj.TrackId.toString();
    let object = aspObjects.tracksPool.getObject(id) as TrackObject;
    if (!object) { return; }

    if (msgObj.Polygon.length < 4) {
      console.error("Impact Point/TBM Polygon has arrived with less than 4 points...");
      object.ip = null;
      object.update();
      return;
    }
    if (object.trackStatus > 1) {
      if (object.ip != null) {
        object.ip = null;
        object.update();
      }
      return;
    }

    //fill data
    object.handleIp(msgObj);
    object.ForceUpdate = true;

    if (userSettings.userPerm == enums.Permission.USER) {
      if (msgObj.CenterPosition != undefined) {
        if (msgObj.CenterPosition.CenterLocLong != undefined && msgObj.CenterPosition.CenterLocLat != undefined) {
          object.dontupdateloc = true;
          object.geometry.x = msgObj.CenterPosition.CenterLocLong * units.RAD_TO_DEG;
          object.geometry.y = msgObj.CenterPosition.CenterLocLat * units.RAD_TO_DEG;
        }
      }
    }

    //update drawing
    object.update();
  }
}
